export default __webpack_public_path__ + "static/media/tomato.0d89a485.jpeg";